
import Vue from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export default Vue.extend({
  name: 'SimpleStencil',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  render(h, { props, data }) {
    return h(props.tag, mergeData(data, { staticClass: 'simple-stencil' }), [
      h('span', { staticClass: 'stencil-element' }),
    ]);
  },
});
